module.exports = __webpack_public_path__ + "img/icons_chrome.2297590.png";